/**
 * Created by quikr on 1/19/17.
 */

import moment from "moment";
export default class csvConvert {
  constructor() {

  }

  convertArrayOfVerticalObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);
    keys = ['empId', 'fullName', 'contactNo', 'officeEmailId', 'officeLocation', 'reportingTo', 'designation', 'department', 'subDepartment', 'function', 'vertical', 'verticalHead','empPayroll','dateOfJoining','empStatus'];
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (key.endsWith('empDOB') || key.endsWith('dateOfJoining'))
          item[key] = moment(item[key]).format('YYYY-MM-DD');
        if(key=='empStatus')
        {
          if(item[key]=='J')
            item[key]='A';
        }

        if (typeof(item[key]) == "string")
          item[key] = item[key].replace(/,/g, "");
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }
  convertArrayOfQCapRatingsToCSV(args) {
    var result, ctr, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }
    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';
    let currentDate = new Date();
    currentDate.setDate(1);
    let previousMonth = currentDate;
    let formattedDate = moment(currentDate).format("YYYY-MM-DD");

    let keys = new Array();
    keys[0]="empId";
    keys[1]="empName";
    keys[2]="vertical";
    keys[3]="function";
    keys[4]="department";

    // previousMonth = moment(previousMonth).subtract(1,'month');
    for(var i =0;i<=11;i++)
    {
      previousMonth = moment(previousMonth).subtract(1,'month');
      let formattedDate = previousMonth.format("YYYY-MM-DD");
      keys.push(formattedDate);
    }

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {

        if(item[key] == undefined)
          item[key]='NA';

        if (typeof(item[key]) == "string")
          item[key] = item[key].replace(/,/g, "");
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }



  convertArrayOfJoinerObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);


    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;
        if (key == 'joiningDate' || key == 'offerDate' || key == 'empDob') {
          result += moment(item[key]).format('YYYY-MM-DD');
          ctr++;
          return;
        }
        if (typeof(item[key]) == "string")
          item[key] = item[key].replace(/,/g, "");
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  convertArrayOfExitObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    keys = ['employeeCode', 'name', 'emailId', 'empPersonalEmailId', 'location', 'payroll', 'doResignation', 'doLeaving',
        'typeOfExit', 'noticePeriodStatus', 'recovery', 'employeeRemarks', 'remarks', 'reportingTo', 'managerName',
        'department', 'subDepartment', 'function', 'designation', 'vertical', 'verticalHead', 'verticalheadName',
        'itStatus', 'adminStatus', 'financeStatus', 'managerStatus','vhStatus', 'empStatus', 'category', 'contactNo', 'revenueStream']
    let keys1 = ['Employee Id', 'Name', 'Email Id Professional', 'Email Id Personal', 'Location', 'Payroll',
        'Date of Resignation', 'Last Working Day', 'Type Of Exit', 'Notice Period Status', 'Recovery', 'Reasons for leaving',
        'Remarks', 'Manager EmpId', 'Manager Name', 'Department', 'SubDepartment', 'Function', 'Designation', 'Vertical',
        'Vertical EmpId', 'Vertical HeadName', 'IT Status', 'Facilities Status', 'Finance Status', 'Manager Status',
        'Verical Head Status', 'Employee Status', 'Category', 'Mobile Number', 'Revenue Stream']

    result = '';
    result += keys1.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {

      ctr = 0;
      keys.forEach(function (key) {
        if (typeof(item[key]) == "string") {
          item[key] = item[key].replace(/,/g, "");
          item[key] = item[key].replace(/(\r\n|\n|\r)/gm, "");
        }

        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  convertArrayOfAnyObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    //keys = Object.keys(data[0]);
    console.log("flattenedss");
    console.log(flattenObject(data[0]));
    data[0]=flattenObject(data[0]);
    keys = Object.keys(data[0]);
    //keys.add(Object.keys(data[0].employee));
    console.log(keys);


    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {
      ctr = 0;
      item = flattenObject(item);
      keys.forEach(function (key) {
        var itemValue = item[key] != null ? String(item[key]) : "";
        if (key.endsWith('empDOB') || key.endsWith('dateOfJoining'))
          itemValue = moment(item[key]).format('YYYY-MM-DD');
        else if (key.endsWith('accountNo'))
          itemValue = 'acc:'+item[key];
        else if (key.endsWith('empUAN'))
          itemValue = 'uan:'+item[key];
        else if (key.endsWith('passportNo'))
          itemValue = 'ifcs:'+item[key];
        else if (key.endsWith('aadharNo'))
          itemValue ='aadharNo:' + item[key];
        itemValue = '"' + itemValue.replace(/\"/g, '""') + '"';
        if (ctr > 0) result += columnDelimiter;
        result += itemValue;
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }
  convertArrayOfQcapObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    //keys = Object.keys(data[0]);
     data[0]=flattenObject(data[0]);
    keys = Object.keys(data[0]);
    //keys.add(Object.keys(data[0].employee));


    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;


    data.forEach(function (item) {
      ctr = 0;
      item = flattenObject(item);
      keys.forEach(function (key) {
        if (typeof(item[key]) == "string") {
          item[key] = item[key].replace(/,/g, "");
          item[key] = item[key].replace(/(\r\n|\n|\r)/gm, "");
        }
        if (!key.endsWith('empId') || key.endsWith('empName') || key.endsWith('Total'))
          item[key] = moment(item[key]).format('MMMM');
        else if (key.endsWith('accountNo'))
          item[key] = 'acc:'+item[key];
        else if (key.endsWith('empUAN'))
          item[key] = 'uan:'+item[key];
        else if (key.endsWith('passportNo'))
          item[key] = 'ifcs:'+item[key];
        else if (key.endsWith('aadharNo'))
          item[key]='aadharNo:' + item[key];

        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }



  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        if (item[key] == 'W')
          item[key] = 'Working';
        else if (item[key] == 'N')
          item[key] = 'WeeklyOff'
        else if (item[key] == 'L')
          item[key] = 'Leave';
        else if (item[key] == 'P')
          item[key] = 'Public Holiday';

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }
}

var flattenObject = function(data) {

  var result = {};
  function recurse (cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for(var i=0, l=cur.length; i<l; i++)
        recurse(cur[i], prop ? prop+"."+i : ""+i);
      if (l == 0)
        result[prop] = [];
    } else {
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop+"."+p : p);
      }
      if (isEmpty)
        result[prop] = {};
    }
  }
  recurse(data, "");
  return result;
};



/** WEBPACK FOOTER **
 ** ./src/classes/csvConvert.js
 **/